import _ from 'underscore';
import parsePhoneNumber from 'libphonenumber-js';
import { phoneFormats } from './phone-format';

export const validatePhone = (phone, allowEmpty = false) => {
  if (!phone) {
    return allowEmpty;
  }

  return phoneFormats[1].validate(phone, allowEmpty);
};

const USCountryId = 191;

export const getCallingCodeDisplayByCountry = (country = {}) => {
  const callingCodeString = _.isEmpty(country.CountryCallingCode) ? '' : ` (+${country.CountryCallingCode})`;
  return `${country.Name || ''}${callingCodeString}`;
};

// FB imported phone number is in format of +12345678890, and there is no dash after the area code
export const matchCountryAndCallingCode = (fullPhoneNumber, location, countries) =>
  _.find(countries, country =>
    fullPhoneNumber.indexOf(`+${country.CountryCallingCode}`) === 0 &&
    location.includes(country.Name));

export const getCountryIdByRegionCode = (regionCode, countries) => {
  const country = _.find(countries, c => c.Code === regionCode);

  if (country) {
    return country.Id;
  }

  return '';
};

export const parseInitialPhoneNumber = (fullPhoneNumber, initialCountryCode, countries, location = '') => {
  if (fullPhoneNumber) {
    if (/^\+(\d+)/.test(fullPhoneNumber)) {
      const matchedCountry = matchCountryAndCallingCode(fullPhoneNumber, location, countries);

      if (matchedCountry) {
        return {
          initialPhoneNumber: fullPhoneNumber.replace(`+${matchedCountry.CountryCallingCode}`, ''),
          initialCountryId: matchedCountry.Id,
          initialCallingCode: matchedCountry.CountryCallingCode,
        };
      } else if (validatePhone(fullPhoneNumber)) {
        let parsedPhoneNumber = null;

        try {
          parsedPhoneNumber = parsePhoneNumber(fullPhoneNumber, initialCountryCode);
        } catch (e) {} // eslint-disable-line no-empty

        if (parsedPhoneNumber) {
          const initialCallingCode = parsedPhoneNumber.countryCallingCode;
          const initialPhoneNumber = fullPhoneNumber.replace(`+${initialCallingCode}`, '');
          const regionCode = parsedPhoneNumber.country;
          const initialCountryId = getCountryIdByRegionCode(regionCode, countries);

          return {
            initialPhoneNumber,
            initialCountryId,
            initialCallingCode,
          };
        }
      }
    } else {
      const matches = fullPhoneNumber.match(/^(\d+)\s?-\s?(.*$)/);
      if (matches) {
        const fromCallingCode =
          _.findWhere(countries, { CountryCallingCode: matches[1] });
        const fromCountryCode =
          _.findWhere(countries, { Code: initialCountryCode });

        let initialCountry = fromCallingCode;

        // This is a tricky fix here that Canada has the same calling code as US.
        // If it can find the country from the address, use that one first.
        if (fromCallingCode &&
          fromCountryCode &&
          fromCallingCode.CountryCallingCode === fromCountryCode.CountryCallingCode) {
          initialCountry = fromCountryCode;
        }

        if (initialCountry) {
          return {
            initialPhoneNumber: matches[2],
            initialCountryId: initialCountry.Id,
            initialCallingCode: initialCountry.CountryCallingCode,
          };
        }
      }
    }
  } else if (initialCountryCode) {
    const initialCountry = _.findWhere(countries, { Code: initialCountryCode });
    if (initialCountry) {
      return {
        initialPhoneNumber: '',
        initialCountryId: initialCountry.Id,
        initialCallingCode: initialCountry.CountryCallingCode,
      };
    }
  }

  return {
    initialPhoneNumber: fullPhoneNumber,
    initialCountryId: USCountryId,
    initialCallingCode: '1',
  };
};

export const composePhoneNumber = (callingCode, phoneNumber) => `${callingCode}-${phoneNumber}`;
